export default "__VITE_ASSET__CZz15HcK__"